import React, { Component } from 'react';
import Http from '../../services/Http';
import apiPath from '../../constants/apiPath';
import url from '../../assets/img/url.png';
import success from '../../assets/img/email-success.png';

class VerifyEmail extends Component {
    constructor(props){
        super(props);
        this.state = {
            is_verify: false
        };
    }
    componentDidMount(){
		if(this.props.match.params.code){
            this.setState({is_verify:true})
			this.VerifyEmail(this.props.match.params.code);
		}else{
            this.setState({is_verify:false})
        }
  	}
      	
	async VerifyEmail(data){
		let path = apiPath.VerifyEmail;		
		var postData = {};
		postData.code =data;
		let options = {
		  method: 'POST',
		  headers: { 'Accept': 'application/json','Content-Type': 'application/json' },
		  body: JSON.stringify(postData)
		}
		let result = await Http(path, options);
		this.setState({ loading: false });
		if (result.ok) {
		  if (result.status === 200) {
			let resultData = await result.json();
			if (resultData.success) {
                this.setState({is_verify:true})
			}else{
				this.setState({is_verify:false})
			}
		  }else{
            this.setState({is_verify:false})
          }
		} else {
            this.setState({is_verify:false})
		}
	}
    render() {
        return (
            
            <div className="app flex-row align-items-center" style={{background:"#fff"}}>
                {this.state.is_verify ? 
               		<div style={{margin:'auto'}}><img src={success} alt="Lavender"/></div> :
                 	<div style={{margin:'auto'}}><img src={url} alt="Lavender"/></div> }
            </div>
        );
    }
}

export default VerifyEmail;
